module.exports = __webpack_public_path__ + "static/img/team_mode_title.3befbc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pk/team_mode_title.png
// module id = 0fVv
// module chunks = 1